/* OTD cart tidy — scoped enhancement for On-the-Day master-calculator line items.
   Runs on the cart page + cart drawer (loaded globally from theme.liquid). It ONLY
   touches a line item's <dl> property list when that list contains a "Total Suite
   Investment" row (unique to the OTD calculator), so every other product is untouched.
   It collapses the long "Pieces" / "On request" rows behind a "See itemised selection
   detail" toggle and emphasises the investment figure — nothing in the cart logic changes. */
(function () {
  var STYLE_ID = 'otd-cart-tidy-css';
  var CALC_URL = '/pages/wedding-day-signs-and-stationery'; // the master OTD calculator page
  var EDIT_URL = CALC_URL + '?otdedit=1'; // restores the saved selection on load
  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style'); s.id = STYLE_ID;
    s.textContent =
      '.otd-cart-toggle{display:block;width:-moz-fit-content;width:fit-content;margin:8px auto 0 0;background:none;border:none;padding:0 0 1px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:500;letter-spacing:1.6px;text-transform:uppercase;text-align:left;color:#7a1c1a;border-bottom:1px solid #e3d0cb;}' +
      '.otd-cart-toggle:hover{border-color:#7a1c1a;}' +
      '.otd-cart-piece{display:block;margin:2px 0;padding-left:12px;text-indent:-12px;}' +
      '.otd-cart-piece:before{content:"\\2022  ";color:#b09a8e;}' +
      '.otd-cart-due{display:block;font-size:10px;letter-spacing:1.8px;text-transform:uppercase;color:#9a8f8a;font-weight:500;margin:0 0 3px;}' +
      '.otd-cart-edit{display:block;width:-moz-fit-content;width:fit-content;margin:6px auto 0 0;font-size:11px;font-weight:500;letter-spacing:1.6px;text-transform:uppercase;color:#7a1c1a;text-decoration:none;border-bottom:1px solid #e3d0cb;}' +
      '.otd-cart-edit:hover{border-color:#7a1c1a;}' +
      /* pre-paid: keep it elegant + minimal, not "on sale" — mute the struck price, brand the $0, drop the red line-discount pill */
      '.otd-cart-prepaid .price__sale{color:#b3a89f !important;font-weight:400 !important;}' +
      '.otd-cart-prepaid .price__regular{color:#7a1c1a !important;}' +
      '.otd-cart-prepaid .discounts{display:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }
  function dtKey(row) {
    var dt = row.querySelector('dt');
    return dt ? (dt.textContent || '').replace(/ /g, ' ').trim().replace(/:\s*$/, '').trim() : '';
  }
  function tidyDl(dl) {
    if (dl.getAttribute('data-otd-tidied')) return;
    var rows = []; for (var i = 0; i < dl.children.length; i++) { if (dl.children[i].tagName === 'DIV') rows.push(dl.children[i]); }
    var isOtd = rows.some(function (r) { return /Total Suite Investment/i.test(dtKey(r)); });
    if (!isOtd) return;
    dl.setAttribute('data-otd-tidied', '1');
    // Point the product link (the deposit product) back to the calculator so the client can re-edit.
    var item = null;
    try {
      var inode = dl;
      for (var w = 0; w < 7 && inode; w++) { inode = inode.parentElement; if (!inode) break; if (inode.querySelector('a[href*="/products/"]')) { item = inode; break; } }
      if (item) { item.classList.add('otd-cart-line'); var titleLink = item.querySelector('a[href*="/products/"]'); if (titleLink) titleLink.setAttribute('href', EDIT_URL); }
    } catch (e) { }
    // Pre-paid (design code applied) → fee is waived at checkout, so the $ deposit isn't "due today".
    var prepaid = rows.some(function (r) { return /^Design$/i.test(dtKey(r)) && /Existing client/i.test((r.querySelector('dd') || {}).textContent || ''); })
      || rows.some(function (r) { return /^Design code/i.test(dtKey(r)); });
    if (item) item.classList.toggle('otd-cart-prepaid', prepaid);
    // The deposit amount already shows in the cart subtotal (and the Discount section when a code is
    // applied), so the per-line price/discount block here is redundant — hide it for a calmer cart.
    try {
      var node = dl, priceEl = null;
      for (var u = 0; u < 6 && node; u++) { node = node.parentElement; if (!node) break; priceEl = node.querySelector('.price'); if (priceEl) break; }
      if (priceEl) priceEl.style.display = 'none';
    } catch (e) { }
    rows.forEach(function (r) {
      var k = dtKey(r);
      // each piece on its own line (split the " | " separated list)
      if (/^Pieces/i.test(k)) {
        var dd = r.querySelector('dd');
        if (dd && (dd.textContent || '').indexOf(' | ') >= 0) {
          dd.innerHTML = dd.textContent.split(' | ').map(function (x) {
            return '<span class="otd-cart-piece">' + x.trim().replace(/</g, '&lt;') + '</span>';
          }).join('');
        }
      }
    });
    var hide = rows.filter(function (r) { return /^(Pieces|On request)/i.test(dtKey(r)); });
    if (!hide.length) return;
    hide.forEach(function (r) { r.style.display = 'none'; });
    var shown = false;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'otd-cart-toggle'; btn.textContent = 'See itemised selection detail';
    btn.addEventListener('click', function () {
      shown = !shown;
      hide.forEach(function (r) { r.style.display = shown ? '' : 'none'; });
      btn.textContent = shown ? 'Hide itemised detail' : 'See itemised selection detail';
    });
    dl.appendChild(btn);
    var edit = document.createElement('a');
    edit.className = 'otd-cart-edit'; edit.href = EDIT_URL; edit.textContent = 'Edit your selection ↗';
    dl.appendChild(edit);
  }
  // STD / INV (and OTD single-piece) lines carry a hidden "_edit_url" property pointing back to
  // their product page (so the customer can edit print options — the calc restores from localStorage).
  // Hidden props aren't rendered in the DOM, so read them from /cart.js and inject the edit link.
  function tidyEditLinks() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (it) {
          var url = it.properties && it.properties._edit_url;
          if (!url || !it.key) return;
          // The cart line element carries the line key in its id (CartDrawer-Item-<key> / CartItem-<key>).
          var line = document.querySelector('[id*="' + it.key + '"]');
          if (!line || line.getAttribute('data-otd-edit')) return;
          line.setAttribute('data-otd-edit', '1');
          var links = line.querySelectorAll('a[href*="/products/"]');
          for (var i = 0; i < links.length; i++) links[i].setAttribute('href', url);
          // This is the $0 Print Configuration line (specs only) — hide its "$0.00" so it doesn't confuse.
          var pr = line.querySelector('.price'); if (pr) pr.style.display = 'none';
          var dl = line.querySelector('dl');
          // Make the product name (the "Product:" value) bold + dark so it reads clearly.
          if (dl) {
            var rows = dl.querySelectorAll('div');
            for (var r = 0; r < rows.length; r++) {
              var dt = rows[r].querySelector('dt');
              if (dt && /^(Product|Bundle)\b/i.test((dt.textContent || '').replace(/ /g, ' ').trim())) {
                var dd = rows[r].querySelector('dd'); if (dd) { dd.style.fontWeight = '600'; dd.style.color = '#2b2422'; }
              }
            }
          }
          var a = document.createElement('a');
          a.className = 'otd-cart-edit'; a.href = url; a.textContent = 'Edit your selection ↗';
          (dl || line).appendChild(a);
        });
      })
      .catch(function () { });
  }
  function run() {
    try {
      ensureStyle();
      var dls = document.querySelectorAll('dl');
      for (var i = 0; i < dls.length; i++) tidyDl(dls[i]);
      tidyEditLinks();
    } catch (e) { /* never break the cart */ }
  }
  var t; function schedule() { clearTimeout(t); t = setTimeout(run, 90); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  try { new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) { }
  ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, schedule); });
})();
